<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 60px;
        left: 24.5px;
        width: 365.63px;
        height: 21.96px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 365.63 21.96">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <path
                {fill}
                d="M303.73,20.87c-1.2-1.36-2.24-2.87-3.47-4.19a4.24,4.24,0,0,0-2-1.37c-1.59-.39-3.13.52-4.69.66a5.68,5.68,0,0,1-1.88-.19,8.09,8.09,0,0,1-3.22-1.71,7.5,7.5,0,0,1-2.17-3,7.77,7.77,0,0,1-.42-3.67A7.33,7.33,0,0,1,289.08,2a8.52,8.52,0,0,1,6.38-.91,6.71,6.71,0,0,1,2.88,1.38,7.63,7.63,0,0,1,2.11,3.11A8.24,8.24,0,0,1,300.87,7a6.62,6.62,0,0,1,0,2.43c-.16.9-.52,1.72-.76,2.59-.38,1.4.47,1.81,5.27,6.67a.54.54,0,0,1,0,.79A18.4,18.4,0,0,1,303.73,20.87ZM298.34,8.54c.3-2.95-2.67-5.1-4.83-5.16a5.35,5.35,0,0,0-5.22,4.85,5.08,5.08,0,0,0,5,5.08A4.89,4.89,0,0,0,298.34,8.54Z"
            />
            <path
                {fill}
                d="M17.64,14.74a1.5,1.5,0,0,1,.17,2.31c-.33,0-.72.08-1.11.08-5.06,0-10.78,0-15.85,0-.76,0-.86-2.42.11-2.42,4.91,0,10.59,0,15.5,0Z"
            />
            <path {fill} d="M17.74,9.57a1.49,1.49,0,0,1,0,2.28H.51c-.33-.44-.45-2,0-2.28Z" />
            <path
                {fill}
                d="M.55,4.48c5.27,0,11.17.07,16.44,0,1,0,1.28,1.86.54,2.2-.34,0-12,0-16.89,0C-.23,6.71-.17,4.48.55,4.48Z"
            />
            <path
                {fill}
                d="M326.05,0a7.32,7.32,0,0,0-7.32,7.32c0,4,7.32,14.64,7.32,14.64s7.32-10.6,7.32-14.64A7.32,7.32,0,0,0,326.05,0Zm0,12.9a5.58,5.58,0,1,1,5.58-5.58A5.57,5.57,0,0,1,326.05,12.9Z"
            />
            <rect {fill} x="344.42" y="5.64" width="21.22" height="1.89" />
            <rect {fill} x="349.31" y="11.17" width="11.43" height="1.89" />
            <rect {fill} x="352.17" y="16.17" width="5.71" height="1.89" />
        </g>
    </g>
</svg>
